module.exports = __webpack_public_path__ + "static/media/line-vertical.eb2e6401.svg";